export default __webpack_public_path__ + "assets/images/127b5e3bed0c8a4175e27ea7383d445b.svg";